import { ProductType } from '../types';
import { HydraQueryParams, useHydraQuery } from './useHydraQuery';

export function useGetProductTypesQuery<D extends ProductType[]>(params?: HydraQueryParams<D>) {
  const { vars, options, key } = params || {};
  return useHydraQuery<D>(key ?? `getProductTypes`, `/api/product_types`, {
    vars,
    options,
  });
}
